import { render, staticRenderFns } from "./SleepApneaGraphSvg.vue?vue&type=template&id=e3b2ec4c&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports